module.exports = __webpack_public_path__ + "static/img/Htlq.1d66d0f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/card/Htlq.jpg
// module id = A7mE
// module chunks = 1